import { SxProps } from '@mui/system'
import { fontSizes } from '../Components/Common/Typography/TypographyStyles'

// Define the dialog title styles
export const dialogTitleStyles: Record<string, SxProps> = {
  root: {
    fontSize: fontSizes.size20,
    fontWeight: 'bold',
  },
}
